import { WelcomeMessageWrapper } from '@/components/chat/WelcomeMessageWrapper';
import { useUser } from '@/hooks/useUser';
import { Trans, useTranslation } from 'react-i18next';

interface WelcomeMessageProps {
  selectedConversation: boolean;
  contactNames?: string[];
}

export function WelcomeMessage({ selectedConversation, contactNames = [] }: WelcomeMessageProps) {
  const user = useUser();
  const { t } = useTranslation('conversations');

  return (
    <div className="flex flex-col align-middle items-center h-full justify-center gap-6">
      <WelcomeMessageWrapper>
        <Trans
          i18nKey={
            selectedConversation
              ? 'welcomeMessage.startMessaging'
              : 'welcomeMessage.selectConversation'
          }
          values={{
            userName: user?.name,
            contactNames: contactNames?.join(', '),
          }}
          components={[<br key="br" />, <span className="text-5xl font-bold" />]}
          t={t}
        />
      </WelcomeMessageWrapper>
    </div>
  );
}
